import { ReducersMapObject } from 'redux'

import { createFeatureSelector, createSelector, Epic } from 'modules/store'

import i18nEpic from './i18n.epics'
import lookupEpic from './lookup.epic'
import routerEpic from './router.epics'

import * as fromShared from '../../shared/store'
import * as fromCore from './core.reducers'
import * as fromLookup from './lookup.reducer'

import * as i18nActions from './i18n.actions'
import * as lookupActions from './lookup.actions'
import * as routerActions from './router.actions'

// Store
// tslint:disable-next-line:no-empty-interface
export interface CoreState {
  core: fromCore.State
  lookups: fromLookup.State
  shared: fromShared.SharedState
}
export const STORE_ID = 'core'

// export const reducers: Reducer<CoreState> = fromCore.reducer

export const reducers: ReducersMapObject = {
  core: fromCore.reducer,
  lookups: fromLookup.reducer,
  shared: fromShared.reducer,
}

// Actions/ActionTypes
export const actions = {
  ...i18nActions,
  ...routerActions,
  ...lookupActions,
  ...fromShared.sharedActions,
}
export { default as I18nActions } from './i18n.actions'
export { default as RouterActions } from './router.actions'
export { default as LookupActions } from './lookup.actions'

// Epics
export const epics: Array<Epic<any>> = [i18nEpic, routerEpic, lookupEpic, ...fromShared.sharedEpics]

// module state selector
export const selectCoreState = createFeatureSelector<CoreState>(STORE_ID)

export const getLookupsState = createSelector(selectCoreState, (state) => state.lookups)
export const getLookups = createSelector(getLookupsState, (state) => state.lookups)
export const getDepartments = createSelector(getLookupsState, (state) => state.departments)

export const getLanguages = createSelector(getLookupsState, fromLookup.getLanguages)
export const getGroups = createSelector(getLookupsState, fromLookup.getGroups)
export const getLocales = createSelector(getLookupsState, fromLookup.getLocales)
export const getLevels = createSelector(getLookupsState, fromLookup.getLevels)
export const getFunctions = createSelector(getLookupsState, fromLookup.getFunctions)
export const getDivisions = createSelector(getLookupsState, fromLookup.getDivisions)

export const getToasterer = createSelector(selectCoreState, (state) => state.shared.toasterer)
export const getToasts = createSelector(getToasterer, fromShared.getToasts)

export const getPersons = createSelector(selectCoreState, (state) => state.shared.persons)
export const getPersonHiearchy = createSelector(getPersons, fromShared.getUserHierarchy)

export const getBonusPeriodsState = createSelector(selectCoreState, (state) => state.shared.bonusPeriods)
export const getActiveBonusPeriod = createSelector(getBonusPeriodsState, fromShared.getActiveBonusPeriod)
export const getBonusPeriods = createSelector(getBonusPeriodsState, fromShared.getBonusPeriods)
export const getUserActiveBonusPeriod = createSelector(getBonusPeriodsState, fromShared.getUserActiveBonusPeriod)
export const getUserBonusPeriods = createSelector(getBonusPeriodsState, fromShared.getUserBonusPeriods)



// WEBPACK FOOTER //
// ./src/app/core/store/index.ts